// hooks/useWeakBrowser.js
import { useEffect, useState } from "react";

export function useWeakBrowser() {
  const [isWeak, setIsWeak] = useState(false);

  useEffect(() => {
    if (typeof navigator === "undefined") return;

    const ua = navigator.userAgent.toLowerCase();
    const isFirefox = ua.includes("firefox");
    const isSafari =
      ua.includes("safari") &&
      !ua.includes("chrome") &&
      !ua.includes("android");

    if (isFirefox || isSafari) {
      setIsWeak(true);
    }
  }, []);

  return isWeak;
}
